import React, { useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { previewPages } from '../data/previewPages';
export function PagePreviewCarousel() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const first = track.children[0] as HTMLElement | undefined;
      if (!first) return;
      const step = first.offsetWidth + 16;
      setActive(Math.min(previewPages.length - 1, Math.round(track.scrollLeft / step)));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  const scrollTo = (index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const target = track.children[index] as HTMLElement | undefined;
    if (target) track.scrollTo({
      left: target.offsetLeft - track.offsetLeft - 20,
      behavior: 'smooth'
    });
  };
  return <section aria-label="Anteprima del materiale" className="mx-auto mt-12 w-full max-w-5xl" data-id="element-105" data-mp="1d58mzbj2l2k6">
      <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-106" data-mp="186e5qe0r3m26">
        👀 Sfoglia l'interno del Protocollo
      </h2>
      <p className="mx-auto mt-2 max-w-md text-center text-sm text-plum/60" style={{
      fontSize: "13px"
    }} data-id="element-107" data-mp="1hy1qxx6ps6v7">
        Alcune delle oltre 160 pagine tratte dai volumi e dai materiali aggiuntivi. Scorri per vederne altre  →
      </p>

      <div className="relative mt-6" data-id="element-108" data-mp="pb78t6xddjkw">
        <div ref={trackRef} className="-mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-px-5 px-5 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-109" data-mp="139dza1zzohaj">
          {previewPages.map((p, i) => <figure key={p.src} className="w-[68%] shrink-0 snap-start sm:w-[260px]" aria-label={`Pagina ${i + 1} di ${previewPages.length}`} data-id="element-110" data-mp="2enj8paiz1jd9" data-mpi={i}>
              <img src={p.src} alt={p.alt} width={1079} height={1350} loading="lazy" decoding="async" className="aspect-[4/5] w-full rounded-xl border border-grape/15 bg-white object-cover shadow-[0_14px_30px_-20px_rgba(15,42,29,0.45)]" data-id="element-111" data-mp="17b0bl0inbsv6" />
            </figure>)}
        </div>

        <button type="button" onClick={() => scrollTo(Math.max(0, active - 1))} disabled={active === 0} aria-label="Pagina precedente" className="absolute -left-2 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-grape/20 bg-white text-grape shadow-md transition-opacity duration-150 ease-out disabled:opacity-0 sm:flex" data-id="element-112" data-mp="omve2asl144t">
          <ChevronLeftIcon className="h-5 w-5" data-id="element-113" data-mp="4vi4u2sh67x8" />
        </button>
        <button type="button" onClick={() => scrollTo(Math.min(previewPages.length - 1, active + 1))} disabled={active === previewPages.length - 1} aria-label="Pagina successiva" className="absolute -right-2 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-grape/20 bg-white text-grape shadow-md transition-opacity duration-150 ease-out disabled:opacity-0 sm:flex" data-id="element-114" data-mp="9vcxaarwf5ke">
          <ChevronRightIcon className="h-5 w-5" data-id="element-115" data-mp="3fk6o3uo8wm68" />
        </button>
      </div>

      <div className="mt-4 flex justify-center gap-1.5" aria-hidden="true" data-id="element-116" data-mp="3asyeoymx10t2">
        {previewPages.map((p, i) => <span key={p.src} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out ${i === active ? 'w-5 bg-grape' : 'w-1.5 bg-grape/25'}`} data-id="element-117" data-mp="35tc5d0a7k4pj" data-mpi={i} />)}
      </div>
    </section>;
}